/**
 |-----------------------------------------------------------------------------
 | vendor/slick.js
 | v1.0.0
 |-----------------------------------------------------------------------------
 |
 | Some description...
 |
 */

/*
 |
 | Some description...
 |
 */

require('slick-carousel');





/*
 |
 | Some description...
 |
 */

if ($('.js-carousel--hero').length > 0) {

	$('.js-carousel--hero').slick({

		// Initialisation
		arrows         : ($('.js-carousel--hero > .c-banner').length > 1) ? true : false,
		autoplay       : true,
		autoplaySpeed  : 6000,
		dots           : ($('.js-carousel--hero > .c-banner').length > 1) ? true : false,
		draggable      : false,
		focusOnSelect  : true,
		infinite       : true,
		pauseOnFocus   : true,
		pauseOnHover   : true,
		rows           : 0,
		slide          : '.c-banner',
		slidesToShow   : 1,
		slidesToScroll : 1,
		speed          : 300

	});
}


/*
 |
 | Some description...
 |
 */

if ($('.js-carousel--latest-news').length > 0) {

	$('.js-carousel--latest-news').slick({

		// Initialisation
		arrows         : false,
		autoplay       : true,
		autoplaySpeed  : 6000,
		dots           : ($('.js-carousel--latest-news > .c-article').length > 1) ? true : false,
		draggable      : false,
		focusOnSelect  : true,
		infinite       : true,
		pauseOnFocus   : true,
		pauseOnHover   : true,
		rows           : 0,
		slide          : '.c-article',
		slidesToShow   : 1,
		slidesToScroll : 1,
		speed          : 300

	});
}


/*
 |
 | Some description...
 |
 */

if ($('.js-carousel--people').length > 0) {

	$('.js-carousel--people').slick({

		// Initialisation
		arrows         : false,
		autoplay       : true,
		autoplaySpeed  : 6000,
		dots           : ($('.js-carousel--people > .c-person').length > 1) ? true : false,
		draggable      : false,
		focusOnSelect  : true,
		infinite       : true,
		pauseOnFocus   : true,
		pauseOnHover   : true,
		rows           : 0,
		slide          : '.c-person',
		slidesToShow   : 1,
		slidesToScroll : 1,
		speed          : 300

	});
}


/*
 |
 | Some description...
 |
 */

if ($('.js-carousel--reviews').length > 0) {

	$('.js-carousel--reviews').slick({

		// Initialisation
		arrows         : false,
		autoplay       : true,
		autoplaySpeed  : 6000,
		dots           : ($('.js-carousel--reviews > .c-review').length > 1) ? true : false,
		draggable      : false,
		focusOnSelect  : true,
		infinite       : true,
		pauseOnFocus   : true,
		pauseOnHover   : true,
		rows           : 0,
		slide          : '.c-review',
		slidesToShow   : 1,
		slidesToScroll : 1,
		speed          : 300

	});
}
